var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _vm.documento.numeroPortaria
            ? _c("el-col", { attrs: { sm: 24 } }, [
                _c("p", { staticClass: "info" }, [
                  _vm._v("Nº da portaria:"),
                  _c("span", [_vm._v(_vm._s(_vm.documento.numeroPortaria))])
                ])
              ])
            : _vm._e(),
          _vm.documento.dataEmissao
            ? _c("el-col", { attrs: { sm: 24 } }, [
                _c("p", { staticClass: "info" }, [
                  _vm._v("Data da portaria:"),
                  _c("span", [_vm._v(_vm._s(_vm.documento.dataEmissao))])
                ])
              ])
            : _vm._e(),
          _vm.documento.dataCriacao
            ? _c("el-col", { attrs: { sm: 24 } }, [
                _c("p", { staticClass: "info" }, [
                  _vm._v("Data da emissão:"),
                  _c("span", [_vm._v(_vm._s(_vm.documento.dataCriacao))])
                ])
              ])
            : _vm._e(),
          (_vm.documento.processo
          ? _vm.documento.processo.numeroProcesso
          : _vm.documento.numeroProcesso)
            ? _c("el-col", { attrs: { sm: 24 } }, [
                _c("p", { staticClass: "info" }, [
                  _vm._v("Nº do processo:"),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.documento.processo
                          ? _vm.documento.processo.numeroProcesso
                          : _vm.documento.numeroProcesso
                      )
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm.documento.nomeRazaoSocialInteressado
            ? _c("el-col", { attrs: { sm: 24 } }, [
                _c("p", { staticClass: "info" }, [
                  _vm._v("Nome/Razão Social do interessado:"),
                  _c("span", [
                    _vm._v(_vm._s(_vm.documento.nomeRazaoSocialInteressado))
                  ])
                ])
              ])
            : _vm._e(),
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Protocolo:"),
              _c("span", [_vm._v(_vm._s(_vm.documento.protocolo))])
            ])
          ]),
          _vm._t("baixar"),
          _c("el-row", { staticClass: "dados-doc" }, [
            _c(
              "div",
              { staticClass: "link-download" },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: "cloud-download-alt" }
                }),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.downloadDoc(_vm.documento.id)
                      }
                    }
                  },
                  [_vm._v("  Baixar Documento")]
                )
              ],
              1
            )
          ]),
          _vm.temMemoriais
            ? _c(
                "div",
                [
                  _c("el-col", { attrs: { sm: 24 } }, [
                    _c("p", { staticClass: "info" }, [
                      _vm._v("Memorial descritivo:")
                    ])
                  ]),
                  _c(
                    "el",
                    { staticClass: "row dados-doc" },
                    _vm._l(_vm.documento.documentoAutenticavelFilhos, function(
                      doc
                    ) {
                      return _c(
                        "div",
                        { key: doc.id },
                        [
                          _c("el-row", { staticClass: "dados-doc" }),
                          _c(
                            "div",
                            { staticClass: "link-download" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "cloud-download-alt" }
                              }),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadDoc(doc.id)
                                    }
                                  }
                                },
                                [_vm._v("  " + _vm._s(doc.nomeDocumento))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a38cefd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a38cefd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/PortariaArrecadacao.vue
// module id = null
// module chunks = 